/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
//import { LandingPage } from "@vlinder-web/landing-page-v2-widget-react";
import { LandingPage } from '../../../widgets/landing-page-v2-widget-react';

import { useTheme } from '../../../providers/theme';

import '@vlinder-web/landing-page-v2-widget-react/lib/js/assets/vendor/bootstrap/css/bootstrap.min.css';
import '@vlinder-web/landing-page-v2-widget-react/lib/js/assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../../../vlp.min.css';
import { VApplication } from '../../../application';
import { LandingPageService } from '../../../services';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.LandingPageService') as LandingPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();

  const staticPageContentConfig = getSrv()?.getStaticPageContent();

  const _renderPage = () => {
    return <LandingPage {...(staticPageContentConfig || {})} />;
  };
  return <>{_renderPage()}</>;
};
